(function() {
	'use strict';
	angular.module('app.core')
		.service('a3ModalService', a3ModalService);
	
	a3ModalService.$inject = ['$uibModal'];
	function a3ModalService($uibModal) {
		var instance = null;
		return {
			openModal: openModal,
			closeModal: closeModal,
			removeNoPrintClass: removeNoPrintClass
		};
		
		function openModal(projectNdx, factoryNdx) {
			instance = $uibModal.open({
				animation: true,
				templateUrl: '/application/f/core/a3/a3.html',
				windowTemplateUrl: '/application/f/core/a3/a3-window-template.html',
				controller: 'a3 as a3Ctrl',
				resolve: {
					projectNdx: function() {
						return projectNdx;
					},
					factoryNdx: function() {
						return factoryNdx;
					},
					closeA3: function() {
						return closeModal;
					}
				}
			});
			return instance;
		}
		
		function closeModal() {
			if (instance) {
				instance.dismiss('cancel');
			}
		}
		
		function removeNoPrintClass() {
			jQuery('.no-print-on-a3').removeClass('no-print-on-a3');
		}
	}
})();